import { Directive, HostListener, Input } from '@angular/core';
import { AnalyticsService } from './analytics.service';

@Directive({
    selector: '[gccTrackClick]',
    standalone: false
})
export class TrackClickDirective {
  @Input() public gccTrackClick: string;

  constructor(private analyticsService: AnalyticsService) {}

  @HostListener('click')
  public trackClick() {
    this.analyticsService.trackClick(this.gccTrackClick);
  }
}
